module.exports = __webpack_public_path__ + "static/img/md-person2.def0cc91.svg";